import React, { Fragment } from 'react';

import { Grid, Typography, Link, withStyles } from '@material-ui/core';
import SuccessTick from '../../svg/SuccessTick';
import styles from './stepsstyles';

const UploadIdDocumentsSuccess = ({ classes }) => {
  return (
    <Fragment>
      <Grid item xs={12} className={classes.iconContainerIdUpload}>
        <SuccessTick width="120px" height="80px" />
      </Grid>
      <Grid item xs={12} md={12} lg={12} xl={12}>
        <Typography variant="h5" className={classes.messageIdUpload} data-testid="workflowMessage">
          We’ve got your request
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12} xl={12}>
        <Typography variant="body2" className={classes.subMessageIdUpload}>
          A member of our team will be in touch in the next business day
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12} xl={12}>
        <Typography
          variant="body2"
          className={classes.websiteLinkIdUpload}
          data-testid="workflowMessage"
        >
          <Link href="https://www.shift.com.au" target="_blank">
            Shift Website
          </Link>
        </Typography>
      </Grid>
    </Fragment>
  );
};

export default withStyles(styles)(UploadIdDocumentsSuccess);
